export function buildFaqURL(lang) {
  const faqURLs = {
    'pt-BR': 'https://ajuda.rdstation.com/s/article/Autenticação-de-dois-fatores?language=pt_BR',
    'en-US': 'https://ajuda.rdstation.com/s/article/Two-factor-authentication?language=en_US',
    'es-ES': 'https://ajuda.rdstation.com/s/article/Autenticaci%C3%B3n-de-dos-factores?language=es',
  }

  return faqURLs[lang]
}

export function buildFaqSecurityAlertURL(lang) {
  const faqSecurityAlertURLs = {
    'pt-BR': 'https://ajuda.rdstation.com/s/article/Alertas-de-Seguran%C3%A7a-Novo-acesso-a-sua-conta?language=pt_BR',
    'en-US': 'https://ajuda.rdstation.com/s/article/Security-Alerts-New-access-to-your-account?language=en_US',
    'es-ES': 'https://ajuda.rdstation.com/s/article/Alertas-de-seguridad-nuevo-acceso-a-tu-cuenta?language=es',
  }

  return faqSecurityAlertURLs[lang]
}

export function buildAppsAuthUrl(lang) {
  const appsAuthUrl = {
    'pt-BR': 'https://ajuda.rdstation.com/s/article/Aplicativos-Autenticadores?language=pt_BR',
    'en-US': 'https://ajuda.rdstation.com/s/article/Authenticator-Apps?language=en_US',
    'es-ES': 'https://ajuda.rdstation.com/s/article/Aplicaciones-de-autenticaci%C3%B3n?language=es',
  }

  return appsAuthUrl[lang]
}
